import React, { useState } from "react";
import { StyledFAQ } from "./styles";
import { allQuestions } from "./staticData";
import { EMAIL_US_AT } from "../constants";

const FAQ = (props) => {
  const [question, setQuestion] = useState("");
  let questions;
  if (props.questions === "mainQuestions") {
    questions = allQuestions.mainQuestions;
  } else {
    //assume pricing page
    questions = allQuestions.pricingQuestions;
  }

  return (
    <StyledFAQ>
      <div className="faq-section-container">
        <section className="faq-section">
          {props.questions !== "mainQuestions" && <span className="faq-pre-headline">WORDS WE LIVE BY</span>}
          {props.questions !== "mainQuestions" && <h1 className="faq-headline">There are no bad questions</h1>}
          {props.questions === "mainQuestions" && <h1 className="faq-headline">Frequently Asked Questions</h1>}
          {props.questions !== "mainQuestions" && (
            <span className="faq-sub-headline">
              We hope we've answered all of yours below.
              <br />
              If not, we're only{" "}
              <a className="only-an-email" href={`mailto:${EMAIL_US_AT}?subject=Question about Sudowrite pricing`}>
                an email away.
              </a>
            </span>
          )}
          <ul className="faq-question-list">
            {questions.map((q, i) => {
              return (
                <li key={"question_" + i}>
                  <p>{q.question}</p>
                  {q.url ? (
                    <a href={q.url} target="_blank" className="faq-answer-link">
                      <p>{q.answer}</p>
                    </a>
                  ) : (
                    q.answer.split("<br/>").map((line, i) => <p key={i}>{line}</p>)
                  )}
                </li>
              );
            })}
          </ul>
          <p className="didnt-see">
            <br />
            <strong>Didn't see your question here?</strong>
            <br />
            <em>Contact us directly!</em>
          </p>
          <div className="button-container">
            <input type="text" placeholder="Do androids dream of electric sheep?" onChange={(e) => setQuestion(e.target.value)} />
            <a href={`mailto:${EMAIL_US_AT}?subject=Question about Sudowrite pricing&body=${question ? question : ""}`}>
              <button className="faq-ask-button">Ask</button>
            </a>
          </div>
        </section>
      </div>
    </StyledFAQ>
  );
};

export default FAQ;
